import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import { memo, useCallback } from 'react';

import { CarouselWrapperStyled } from './styled/CarouselStyled';
import CarouselControlIcon from './CarouselControlIcon';
import { CarouselProps } from 'react-responsive-carousel/lib/ts/components/Carousel/types';

type ICarouselProps = Partial<CarouselProps> & {
    centerDots?: boolean;
    children: JSX.Element[];
    className?: string;
    dotsLeftOffset?: number;
    showArrows?: boolean;
    showStatus?: boolean;
    showThumbs?: boolean;
}

export const Carousel = memo(
    ({
         children,
         centerDots,
         className,
         dotsLeftOffset,
         showArrows = true,
         showStatus = false,
         showThumbs = false,
         ...carouselProps
     }: ICarouselProps) => {
        const renderArrowNext = useCallback(
            (handleClick, hasNext) => <CarouselControlIcon onClick={handleClick} hasNext={hasNext}/>,
            [],
        );
        const renderArrowPrev = useCallback(
            (handleClick, hasNext) => <CarouselControlIcon onClick={handleClick} hasNext={hasNext} prev/>,
            [],
        );

        return (
            <CarouselWrapperStyled centerDots={centerDots} dotsLeftOffset={dotsLeftOffset} className={className}>
                <ResponsiveCarousel
                    renderArrowNext={showArrows ? renderArrowNext : void 0}
                    renderArrowPrev={showArrows ? renderArrowPrev : void 0}
                    showArrows={showArrows}
                    showStatus={showStatus}
                    showThumbs={showThumbs}
                    preventMovementUntilSwipeScrollTolerance
                    {...carouselProps}
                >
                    {children}
                </ResponsiveCarousel>
            </CarouselWrapperStyled>
        );
    },
);
